import { render, staticRenderFns } from "./WarnData.vue?vue&type=template&id=8ad40592&scoped=true"
import script from "./WarnData.vue?vue&type=script&lang=js"
export * from "./WarnData.vue?vue&type=script&lang=js"
import style0 from "./WarnData.vue?vue&type=style&index=0&id=8ad40592&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ad40592",
  null
  
)

export default component.exports